import { render, staticRenderFns } from "./index-old.vue?vue&type=template&id=d8e39548&scoped=true&"
import script from "./index-old.vue?vue&type=script&lang=js&"
export * from "./index-old.vue?vue&type=script&lang=js&"
import style0 from "./index-old.vue?vue&type=style&index=0&id=d8e39548&lang=scss&"
import style1 from "./index-old.vue?vue&type=style&index=1&id=d8e39548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8e39548",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8e39548')) {
      api.createRecord('d8e39548', component.options)
    } else {
      api.reload('d8e39548', component.options)
    }
    module.hot.accept("./index-old.vue?vue&type=template&id=d8e39548&scoped=true&", function () {
      api.rerender('d8e39548', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/index-old.vue"
export default component.exports